import { render, staticRenderFns } from "./DoubleImage.vue?vue&type=template&id=99ab5160"
import script from "./DoubleImage.vue?vue&type=script&lang=js"
export * from "./DoubleImage.vue?vue&type=script&lang=js"
import style0 from "./DoubleImage.vue?vue&type=style&index=0&id=99ab5160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports